"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexFilterValuesSchema = {
    id: '/IndexFilterValues',
    additionalProperties: {
        oneOf: [{ $ref: '/Number' }, { $ref: '/Address' }, { $ref: '/OrderHashSchema' }],
    },
    type: 'object',
};
//# sourceMappingURL=index_filter_values_schema.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@0xproject/json-schemas/lib/schemas/index_filter_values_schema.js
// module id = 470
// module chunks = 0